var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToParticipate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75 67.022V6C75 2.68629 72.3137 0 69 0H7.98C3.57304 0 0 3.57304 0 7.98V69.004C0 72.3177 2.68629 75.004 6 75.004H67.022C71.427 75.002 75 71.4289 75 67.022ZM34.2581 67.0938C30.5275 67.0938 27.4931 63.9058 27.4931 60.1732C27.4931 56.4405 30.5275 53.3303 34.2581 53.3303C38.0686 53.3303 41.103 56.4405 41.103 60.1732C41.103 63.9058 38.0706 67.0938 34.2581 67.0938ZM46.3897 38.3219C43.2875 40.6122 40.4127 42.4416 39.2077 45.3064C38.2561 47.5747 36.696 49.6755 34.2362 49.6755C31.6899 49.6755 29.4516 47.7276 29.7569 45.1996C30.0009 43.1799 30.6044 41.3447 31.6147 39.6446C34.2561 35.0581 41.1808 32.2591 41.1808 25.4163C41.1808 22.0727 39.08 19.7405 35.116 19.7405C33.8139 19.7405 32.5663 19.9886 31.3854 20.4309C27.8576 21.7522 23.0563 21.1624 21.6697 17.6597C20.7659 15.3715 21.538 12.1914 23.6826 10.9904C27.6646 8.75805 32.1275 7.80045 36.9035 7.92015C46.7009 8.30917 53.5438 13.3625 53.6994 22.8487C53.7014 28.6801 52.0675 34.1245 46.3897 38.3219Z",
    fill: "#EAF0FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToParticipate);
export default __webpack_public_path__ + "static/media/howToParticipate.24fbc0f974bc331f5f5a061c5e163c14.svg";
export { ForwardRef as ReactComponent };